
<script>
export default {
  name: "CmsMenuPopinSeo",
  props: {
    menu: {
      type: [Array, Object],
      default: () => {}
    }
  },
  data() {
    return {
      menuToPrint: []
    };
  },
  methods: {
    menuSeo(menuData) {
      for (let i = 0, count = menuData.length; i < count; i++) {
        if (menuData[i].attributes.children.data.length === 0) {
          this.menuToPrint.push(menuData[i]);
        } else {
          this.menuSeo(menuData[i].attributes.children.data);
        }
      }
    }
  },
  created() {
    this.menuSeo(this.menu);
  }
};
</script>

<template>
  <div class="u-none">
    <ul>
      <li
        v-for="item in menuToPrint"
        :key="`cms-menu-seo-${item.id}`"
      >
        <a :href="item.attributes.slug">
          {{ item.attributes.libelle }}
        </a>
      </li>
    </ul>
  </div>
</template>
